import React from 'react';
import {
	Radar,
	RadarChart,
	PolarAngleAxis,
	PolarRadiusAxis,
	PolarGrid,
	ResponsiveContainer,
	Tooltip,
	Legend,
} from 'recharts';

const Radarchart = props => {
	const { containerProps, chartProps, data, axisKey, radarData, domain, formatter } = props;

	return (
		<ResponsiveContainer width="100%" height="80%" aspect={4.0 / 3.4} {...containerProps}>
			<RadarChart outerRadius={150} data={data} {...chartProps}>
				<PolarGrid />
				<PolarAngleAxis dataKey={axisKey} />
				<PolarRadiusAxis angle={30} domain={domain} />
				<Radar
					name={radarData.name}
					dataKey={radarData.key}
					stroke={radarData.stroke || '#4caf50'}
					fill={radarData.fill || '#e8f5e9'}
					fillOpacity={0.6}
				/>
				<Tooltip formatter={value => (formatter ? `${value} ${formatter}` : value)} />
				<Legend />
			</RadarChart>
		</ResponsiveContainer>
	);
};

export default Radarchart;
